import { getRandomExampleHeader } from '@app/api/utils/mock'
import {
  ApiGetDwhSettingsByBridgeIdResponse,
  ApiErrorResponse,
} from 'BackendApi'
import { endpoints } from '@app/api/config'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { useQuery } from 'react-query'

const fetchDwhSettingsByBridgeId = async (
  bridgeId: string
): Promise<ApiGetDwhSettingsByBridgeIdResponse> => {
  const apiResponse = await apiAuthClient.get(
    endpoints.getDwhSettingsByBridgeId({ bridgeId }),
    {
      headers: {
        ...getRandomExampleHeader(['example-1']),
      },
    }
  )
  return apiResponse.data
}

export const useGetDwhSettingsByBridgeId = (
  bridgeId?: string
) =>
  useQuery<ApiGetDwhSettingsByBridgeIdResponse, ApiErrorResponse>(
    ['dwhSettings', bridgeId],
    () => fetchDwhSettingsByBridgeId(bridgeId!),
    {
      staleTime: 0,
    }
  )
